import { useReduxState } from 'hooks';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesCalendarEvents
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleCalendarEventsAvailable = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url =
    `/admin/calendar-events?` +
    `minimal=true&` +
    `view=list&` +
    `page=1&` +
    `limit=${module.limit}&` +
    `timeFrame=current&` +
    `status=available`;

  return (
    <div>
      <HomePageSettingsTilesCalendarEvents module={module} url={url} />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.homePageSettingsModulesNumberOfCalendarEvents,
            value: `${messages.homePageSettingsModulesLimitMax} ${module.limit}`
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          module={module}
          onUpdate={updateModule}
          productType="calendar-event"
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleCalendarEventsAvailable;
